<template>
  <div class="card-container">
    <div class="card">
      <img :src="image" alt="produto" class="product-img" />
      <div>
        <div class="title-info">
          <h4 class="title">
            {{ name }}
            <span>
              <div class="info-container">
                <div class="info-icon desktop"></div>
                <div
                  class="info-icon mobile"
                  id="info-produto"
                  @click.stop="tooltipHandler($event)"
                ></div>
                <div class="more-info-container" data-tooltip="info-produto">
                  <div class="more-info">
                    <div
                      class="close-button"
                      id="info-produto"
                      @click="tooltipHandler($event)"
                    >
                      <div class="bar1"></div>
                      <div class="bar2"></div>
                    </div>
                    <p class="more-info-title">Ingredientes</p>
                    <p>{{ ingredients }}</p>
                    <p class="more-info-title">Alergénios</p>
                    <p>{{ allergens }}</p>
                  </div>
                </div>
              </div>
            </span>
          </h4>
        </div>

        <div :class="'quantity-price ' + (units > 0 ? 'has-pieces' : '')">
          <h4 class="quantity">
            {{ units }} {{ units > 1 ? "peças" : "peça" }}
          </h4>
          <h4 class="price">{{ price }} €</h4>
        </div>
      </div>

      <div v-if="qty > 0" class="quantity-button">
        <button
          class="minus"
          @click="removeFromCart"
          wire:loading.class="disabled"
        >
          -
        </button>
        <span class="amount">
          {{ qty }}
        </span>
        <button class="plus" @click="addToCart" wire:loading.class="disabled">
          +
        </button>
      </div>

      <button
        v-else
        @click="addToCart"
        wire:loading.class="disabled"
        class="btn-bg"
      >
        Adicionar ao carrinho
      </button>
    </div>
  </div>
</template>

<script>
// import image from '../../img/Aburi-Salmon-nigiri.png'
export default {
  props: {
    productInfo: {
      required: true,
    },
    productQuantity: {
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      image: this.productInfo.product_types[0].images.l,
      name: this.productInfo.name,
      allergens: this.productInfo.allergens,
      ingredients: this.productInfo.product_types[0].ingredients,
      units: this.productInfo.product_types[0].number_units,
      price: this.productInfo.product_types[0].price,
      qty: this.productQuantity,
    };
  },
  methods: {
    addToCart() {
      Livewire.emit(
        "addToCartSuggestion",
        this.productInfo.product_types[0].code
      );
      this.qty++;
    },
    removeFromCart() {
      Livewire.emit(
        "removeFromCartSuggestion",
        this.productInfo.product_types[0].code
      );
      this.qty--;
    },
  },

  // Nao sei se será necessário, podes passar por prop a quantity - Lucas
  /* mounted() {
        Livewire.on('addCartSuggestion', this.productQuantity = this.productQuantity + 1);
        Livewire.on('removeCartSuggestion', this.productQuantity = this.productQuantity - 1);
    } */
};
</script>

<style>
</style>
